<template>
  <div>
    <span class="color-complementary-300 font-size-16">
      {{ item.name }}
    </span>
    <div v-if="itemIndex">
      <Checkbox
        :label="$lang.previousExercisePrerequisite"
        :value="item.enable"
        name="enable"
        rowClass="flex-start margin-top-8 margin-bottom-0 padding-x-8"
        :loading="loading"
        :disabled="
          !checkPermission(permissions, ['admin', 'edit']) || isReadonly
        "
        @change="handleChange"
      />
      <div class="color-complementary-200 font-size-10 margin-x-8">
        {{ item.exercisePrerequisite }}
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox } from "@/components/re-design/forms";
import { inject, ref, toRefs } from "vue";
import { pathOr } from "ramda";
import { checkPermission, generateError, toastAlert } from "@/shared/utils";
import { setCenterExecuteExercisePrerequisite } from "@/modules/kanoon/services";
export default {
  components: { Checkbox },
  props: {
    item: {
      type: Object,
      default: null,
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    // bind props
    const { item } = toRefs(props);

    // bind injects
    const centerExecuteData = inject("CENTER_EXECUTE_DATA");
    const isReadonly = inject("IS_READONLY");

    const handleReload = () => emit("handleReload");

    const loading = ref(false);
    const handleChange = async (state) => {
      try {
        loading.value = true;
        const { id } = item.value;
        const { id: centerExecuteId } = centerExecuteData.value;
        const response = await setCenterExecuteExercisePrerequisite(
          centerExecuteId,
          id,
          +state
        );
        const { message } = response;
        toastAlert(message);
        handleReload();
      } catch (error) {
        generateError(error);
      } finally {
        loading.value = false;
      }
    };

    // return data to be used in template
    return { pathOr, checkPermission, handleChange, loading, isReadonly };
  },
};
</script>
